import Upsertable from '@/models/Upsertable'
import { useSurveyQuestionStore } from '@/stores/surveyQuestionStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class SurveyQuestion extends Upsertable {
  static store() {
    return useSurveyQuestionStore()
  }

  store() {
    return SurveyQuestion.store()
  }

  static all() {
    return SurveyQuestion.store().getAll
  }

  static find(uuid) {
    const obj = SurveyQuestion.store().find(uuid)
    let survey_question = new SurveyQuestion()
    return Object.assign(survey_question, obj)
  }

  static find_all_by_survey_uuid(survey_uuid) {
    return SurveyQuestion.store()
      .all()
      .filter((survey_question) => survey_question.target_uuid == survey_uuid)
  }
}

useModelName(SurveyQuestion, "SurveyQuestion")
ModelRegistry.register(SurveyQuestion, "SurveyQuestion")